import offshoreDrillingImage from "../assets/clients/global_jackup_rig.png";
import omSupportImage from "../assets/images/o_and_m_support_service.jpg";
import workoverImage from "../assets/replacements/workover_rig_day.png";
import productionImage from "../assets/images/bahrain.jpg";
import workforceImage from "../assets/images/prof_growth.jpg";
import engineeringImage from "../assets/images/energy_infrastructure.jpg";
import globalMapImage from "../assets/replacements/offshore_platform_mist.png";
import { ROUTES } from "../constants/routes";

export const featuredProjectsContent = {
  eyebrow: "Projects & Operational Experience",
  title: "Delivering Performance Across",
  titleAccent: "Complex Energy Operations",
  intro:
    "Reliable operational support, workforce solutions, and project execution across challenging offshore and onshore energy environments.",
  projects: [
    {
      title: "Offshore Drilling Operations",
      image: offshoreDrillingImage,
      description:
        "Extensive experience supporting offshore drilling projects across jack-up rigs and demanding offshore environments.",
    },
    {
      title: "Rig Operations & Maintenance",
      image: omSupportImage,
      description:
        "Comprehensive operational and workforce support for drilling and workover assets through rig operations and maintenance.",
    },
    {
      title: "Workover & Well Intervention",
      image: workoverImage,
      description:
        "Supporting well intervention, production enhancement, and rehabilitation to restore performance and maximize reservoir value.",
    },
    {
      title: "Production Support Services",
      image: productionImage,
      description:
        "Supporting production, maintenance, and exploration activities for major operators across offshore and onshore environments.",
    },
    {
      title: "Technical Workforce Solutions",
      image: workforceImage,
      description:
        "Deploying certified professionals across drilling, workover, and maintenance disciplines with rapid mobilization capability.",
    },
    {
      title: "Engineering & Maintenance Support",
      image: engineeringImage,
      description:
        "Delivering mechanical, electrical, and engineering support alongside maintenance and asset integrity programs.",
    },
  ],
  ctaLabel: "Explore All Projects",
  ctaLink: ROUTES.PROJECTS,
};

export const homeGlobalPresenceContent = {
  image: globalMapImage,
  eyebrow: "Global Presence",
  title: "Supporting Energy Projects",
  titleAccent: "Across Key Markets",
  intro:
    "SAC supports energy projects across India, the Middle East, Southeast Asia, Africa, and the CIS region through workforce deployment, operational support, and project execution.",
  regions: [
    {
      name: "India",
      description:
        "Drilling support, workover operations, maintenance, production support, workforce deployment, and project services across major energy assets nationwide.",
    },
    {
      name: "Middle East",
      description:
        "Workforce deployment, crew management, drilling support, operations & maintenance, engineering support, and project services across the GCC region.",
    },
    {
      name: "Southeast Asia",
      description:
        "Offshore drilling support, workforce deployment, crew management, operations & maintenance, and maintenance support across Indonesia, Malaysia, and the region.",
    },
    {
      name: "Africa",
      description:
        "Drilling support, workforce deployment, crew management, maintenance services, engineering support, and project services across North and Sub-Saharan Africa.",
    },
    {
      name: "CIS Region",
      description:
        "Workforce deployment, drilling support, operations & maintenance, engineering support, and project services for offshore and onshore drilling projects.",
    },
  ],
  stats: [
    { value: "2200+", label: "Certified Professionals" },
    { value: "44+", label: "Active Rigs Supported" },
    { value: "24/7", label: "Operational Support" },
  ],
};

export const homeCtaContent = {
  eyebrow: "Our Commitment",
  title: "Building Long-Term Energy Partnerships",
  paragraphs: [
    "Every client engagement is approached with a long-term perspective focused on operational excellence, technical expertise, workforce capability, and measurable value.",
  ],
  objectiveLead: "Our objective is not merely to provide services.",
  objective: "Our objective is to become the trusted partner our clients rely on when operational excellence matters most.",
  primaryLabel: "Request Consultation",
  primaryLink: ROUTES.CONTACT,
  secondaryLabel: "Explore Our Services",
  secondaryLink: ROUTES.SERVICES,
};

export const homePartnerContent = {
  eyebrow: "Why Partner With SAC",
  title: "Why Partner With",
  titleAccent: "SAC",
  cards: [
    {
      title: "Integrated Energy Services",
      description: "Supporting the complete operational lifecycle of energy assets.",
    },
    {
      title: "Operational Expertise",
      description:
        "Extensive experience across drilling, workover, maintenance, and production support.",
    },
    {
      title: "Rapid Workforce Mobilization",
      description:
        "Deploying skilled professionals quickly while maintaining competency and compliance.",
    },
    {
      title: "Long-Term Partnerships",
      description:
        "Building trusted client relationships through operational excellence and consistent performance.",
    },
  ],
  formEyebrow: "Quick Inquiry",
  formTitle: "Let's Discuss Your Project",
  formButton: "Request Consultation",
};
